import { render, staticRenderFns } from "./editQues.vue?vue&type=template&id=28efbb66&"
import script from "./editQues.vue?vue&type=script&lang=js&"
export * from "./editQues.vue?vue&type=script&lang=js&"
import style0 from "./editQues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports